export default {
    name: 'animations',
    store() {
        return {
            enabled: true,
            init() {
            }
        }
    }
}
